import { Link } from '@/core'
import { AuthContent } from '@c/auth-app/auth-content'
import { useTranslation } from 'react-i18next'
import styles from './style.module.styl'

export const ForgotPasswordSuccessPage = () => {
  const { t } = useTranslation()

  return (
    <AuthContent
      title={t('auth.forgotPasswordSuccessPage.title')}
      extra={
        <Link name="login">
          {t('auth.forgotPasswordSuccessPage.links.return_login')}
        </Link>
      }
    >
      <p className={styles.detail}>
        {t('auth.forgotPasswordSuccessPage.message')}
      </p>
    </AuthContent>
  )
}
